import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'columnFreezeFilter',
})
export class ColumnFreezeFilterPipe implements PipeTransform {

  transform(columns: any[], args?: any): any[] {
    return !columns ? [] : columns.filter( (c: any) => {
       return args.filter(f =>  f.name === c.name ).length === 0;
    } );
  }
}
